import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ProgressbarModule } from "ngx-bootstrap/progressbar";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { TabsModule } from "ngx-bootstrap/tabs";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { AlertModule } from "ngx-bootstrap/alert";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { ModalModule } from "ngx-bootstrap/modal";
import { PopoverModule } from "ngx-bootstrap/popover";
import { CarouselModule } from 'ngx-owl-carousel-o';
import { PersonalComponent } from "./personal/personal.component";
import { MainComponent } from "./main/main.component";
import { NftComponent } from "./nft/nft.component";
import { FaqComponent } from "./faq/faq.component";
import { LeaderBoardComponent } from "./leader-board/leader-board.component";
import { SwiperModule } from 'swiper/angular';
import { ConnectComponent } from "./connect/connect.component";

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    RouterModule,
    BsDropdownModule.forRoot(),
    ProgressbarModule.forRoot(),
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    CollapseModule.forRoot(),
    TabsModule.forRoot(),
    PaginationModule.forRoot(),
    AlertModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    ReactiveFormsModule,
    CarouselModule,
    SwiperModule
  ],
  declarations: [
    PersonalComponent,
    MainComponent,
    NftComponent,
    FaqComponent,
    LeaderBoardComponent,
    ConnectComponent
  ],
  exports: [
  ],
  providers: []
})
export class PagesModule { }
